module.exports = __webpack_public_path__ + "img/product_image_not_available.462861b2.webp";